import queryString from "query-string";

export type PackageView = "calendar" | "leagues" | "annual";

export const getPackageView = (search: string): PackageView => {
  const view = queryString.parse(search).view;
  return view === "links" ? "leagues" : view === "annual" ? "annual" : "calendar";
};

export const buildPackageViewSearch = (search: string, view: PackageView): string => {
  const query = queryString.parse(search);
  if (view === "leagues") query.view = "links";
  else if (view === "annual") query.view = "annual";
  else delete query.view;
  const serialized = queryString.stringify(query);
  return serialized ? `?${serialized}` : "";
};
